import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  metricPicker: {
    display: 'flex',
    flexWrap: 'wrap',
    ...shorthands.gap('12px'),
  },
});
